import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { institucionFinancieraRequest, institucionFinancieraEdit, institucionFinancieraForm } from "../models/institucionFinanciera";

const mutuosVigentes = async (rut: string) => {
    const response: AxiosResponse = await axiosInstance.get(`siscred-api-maestros/v1/institucion-financiera/tiene-mutuo`, {
        params: {
            rut: rut
          },
        });
    return response;
};


const actualizarInstitucionService = async (dataRequest: institucionFinancieraEdit) => {
    const response: AxiosResponse = await axiosInstance.put(`siscred-api-maestros/v1/institucion-financiera/actualizar/${dataRequest.rut}`, dataRequest);
    return response;
};

const crearInstitucionService = async (dataRequest: institucionFinancieraForm) => {
    const response: AxiosResponse = await axiosInstance.post(`siscred-api-maestros/v1/institucion-financiera/crear`, dataRequest);
    return response;
};

export {
    actualizarInstitucionService,
    crearInstitucionService,
    mutuosVigentes
}
